import { PanelBase, TPositionAlign } from "./PanelBase";
import { grey } from "@material-ui/core/colors";
import InfoIcon from '@material-ui/icons/Info';
import React, { useState, useEffect } from "react";

export interface IPanelProps {
    title?: string,
    colorTitle?: string,
    colorBar?: string,
    width?: string,
    top?: string,
    spaceRight?: string,
    resizeable?: boolean,
    isDragged?: boolean,
    zIndex?: number,
    positionAlign?: TPositionAlign,
    showPanel?: boolean,
    showExpanded?: boolean,
    spaceToolbar?: boolean,
    iconBar?: JSX.Element
    onButtonCloseClicked?(value: boolean): any
}

export const PanelLayers: React.FC<IPanelProps> = ({
    title,
    colorTitle = 'black',
    colorBar = grey[900],
    width = '450px',
    top,
    spaceRight,
    resizeable,
    isDragged,
    zIndex = 1000,
    positionAlign = 'right',
    showPanel = false,
    showExpanded = true,
    spaceToolbar = true,
    iconBar = (<InfoIcon />),
    onButtonCloseClicked,
    children
}) => {

    const [showLocalPanel, setShowLocalPanel] = useState(showPanel);

    useEffect(() => {
        setShowLocalPanel(showPanel);
    }, [showPanel]);

    return showLocalPanel ? (
        <PanelBase
            title={title!}
            colorTitle={colorTitle}
            colorBar={colorBar}
            width={width}
            top={top}
            spaceRight={spaceRight}
            resizeable={resizeable}
            isDragged={isDragged}
            zIndex={zIndex}
            showExpanded={showExpanded}
            positionAlign={positionAlign}
            iconBar={iconBar as JSX.Element}
            clickClosePanel={() => {
                setShowLocalPanel(false);
                onButtonCloseClicked!(false);
            }}
            spaceToolbar={spaceToolbar}
        >
            {children}
        </PanelBase>
    ) : null;
}